<template>
    <li class="card export-group p-2 ms-5-r">
        <div class="card-header">
            <a class="accordion-toggle frut-55-roman collapsed" data-toggle="collapse" v-bind:href="target" v-bind:data-target="target" aria-expanded="false" v-bind:aria-controls="id">
                {{ formatGroup.name }}
            </a>
        </div>
        <div v-bind:id="id" class="collapse" style="">
            <ExportFormat v-for="format in formatGroup.formats" v-bind:format="format" v-bind:key="format.id" v-bind:values="values"></ExportFormat>
        </div>
    </li>
</template>

<script>
    import ExportFormat from './ExportFormat.vue';

    export default {
        name: 'ExportGroup',
        components: {
            ExportFormat
        },
        props: {
            formatGroup: {
                type: Object,
                default: () => {
                    return {
                        id: "",
                        name: "",
                        formats: []
                    }
                }
            },
            values: {
                type: Object,
                default: () => {
                    return {
                        requestedExports: [],
                        max: 5
                    }
                }
            }
        },
        computed: {
            target() {
                return "#ef-" + this.formatGroup.id;
            },
            id() {
                return "ef-" + this.formatGroup.id;
            }
        } 
    };
</script>

<style scoped>
    .export-group {
        background-color: var(--ul-light-gray-bg);
    }
</style>